import { render, staticRenderFns } from "./aktivitas.vue?vue&type=template&id=58c51f84"
import script from "./aktivitas.vue?vue&type=script&lang=js"
export * from "./aktivitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports